import styled from 'styled-components';

const Overlay = styled.div`
  background-color: white;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.8;
`;

export default { Overlay };
